"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WHITE_COLORS = exports.SELECTED_COLOR_ICON_SIZE = exports.OPTION_HEIGHT = exports.COLOR_OPTION_ICON = exports.COLOR_ICON_SIZE = exports.CLEAR_ICON = exports.BASE_OPTION_SELECTED = exports.BASE_OPTION_LABEL = exports.BASE_OPTION = void 0;
const COLOR_ICON_SIZE = exports.COLOR_ICON_SIZE = 20;
const SELECTED_COLOR_ICON_SIZE = exports.SELECTED_COLOR_ICON_SIZE = 24;
const OPTION_HEIGHT = exports.OPTION_HEIGHT = 40;
const WHITE_COLORS = exports.WHITE_COLORS = [
    'white',
    '#fff',
    '#FFF',
    '#ffff',
    '#FFFF',
    '#ffffff',
    '#FFFFFF'
];
const BASE_OPTION_LABEL = exports.BASE_OPTION_LABEL = 'base-option-label';
const BASE_OPTION = exports.BASE_OPTION = 'base-option';
const BASE_OPTION_SELECTED = exports.BASE_OPTION_SELECTED = "".concat(BASE_OPTION, "-selected");
const CLEAR_ICON = exports.CLEAR_ICON = 'ClearIcon'; // based on ori ui
const COLOR_OPTION_ICON = exports.COLOR_OPTION_ICON = 'color-option-icon';
